export const ENUM_STATUS_IMPORTER = Object.freeze({
  IDLE: "IDLE",
  PENDENTE: "PENDENTE",
  PROCESSANDO: "PROCESSANDO",
  CONCLUIDO: "CONCLUIDO",
  ERRO: "ERRO",
});

export const STATUS_IMPORTER_LABEL = Object.freeze({
  [ENUM_STATUS_IMPORTER.PROCESSANDO]: "Processando",
  [ENUM_STATUS_IMPORTER.PENDENTE]: "Pendente",
  [ENUM_STATUS_IMPORTER.ERRO]: "Erro",
  [ENUM_STATUS_IMPORTER.CONCLUIDO]: "Concluído",
});

export const STATUS_IMPORTER_COLOR = Object.freeze({
  [ENUM_STATUS_IMPORTER.PROCESSANDO]: "bg-deep-blue text-white",
  [ENUM_STATUS_IMPORTER.PENDENTE]: "bg-warning text-dark",
  [ENUM_STATUS_IMPORTER.ERRO]: "bg-danger text-white",
  [ENUM_STATUS_IMPORTER.CONCLUIDO]: "bg-success text-white",
});
